import { useState } from "react";
import { createContext } from "react";

export const EnvContext = createContext({
    selectedEnvironment: "",
    setSelectedEnvironment: () => null,
}
);

export const EnvironmentProvider = ({children}) => {
    const [selectedEnvironment, setSelectedEnvironment] = useState(null);
    const value = {selectedEnvironment, setSelectedEnvironment};
    return <EnvContext.Provider value={value}>{children}</EnvContext.Provider>
};
